export function DeleteButtonIcon({
  width = 22,
  height = 22,
  className = '',
}: {
  width?: number;
  height?: number;
  className?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.63672 3.60693L10.6543 8.79248L13.6719 3.60693H16.4941L12.1973 10.6479L16.6016 17.8257H13.75L10.6543 12.5425L7.55859 17.8257H4.69727L9.11133 10.6479L4.80469 3.60693H7.63672Z"
        fill="#FF0404"
      />
    </svg>
  );
}

export default DeleteButtonIcon;
